"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnackbar = void 0;
const react_1 = require("react");
const useSnackbar = () => {
    const [snackbarNotifications, setSnackbarNotifications] = (0, react_1.useState)([]);
    const [_, setToastTimeout] = (0, react_1.useState)({});
    const addNotification = (0, react_1.useCallback)((_a) => {
        var { id, message } = _a, rest = __rest(_a, ["id", "message"]);
        setSnackbarNotifications(prevSnackBarNotifications => {
            return prevSnackBarNotifications.concat(Object.assign({ id,
                message }, rest));
        });
    }, []);
    const removeNotification = (0, react_1.useCallback)((id) => {
        setSnackbarNotifications(prevSnackbarNotifications => {
            return prevSnackbarNotifications.filter(notification => notification.id !== id);
        });
        setToastTimeout(prevToastTimeout => {
            delete prevToastTimeout[id];
            return prevToastTimeout;
        });
    }, [setSnackbarNotifications, setToastTimeout]);
    const scheduleNotificationForRemoval = (0, react_1.useCallback)((idToRemove, timeout) => {
        const timeoutId = window.setTimeout(() => removeNotification(idToRemove), timeout);
        setToastTimeout(prevToastTimeout => {
            if (!prevToastTimeout[idToRemove]) {
                return Object.assign(Object.assign({}, prevToastTimeout), { [idToRemove]: timeoutId });
            }
            else {
                return prevToastTimeout;
            }
        });
        return () => {
            clearTimeout(timeoutId);
        };
    }, [removeNotification]);
    return {
        snackbarNotifications,
        removeNotification,
        scheduleNotificationForRemoval,
        addNotification,
    };
};
exports.useSnackbar = useSnackbar;
//# sourceMappingURL=use_snackbar.js.map